<script setup>

    import { useStageStore } from '@/stores/stage';
    import { computed } from 'vue'
    import { useI18n } from 'vue-i18n'

    import EndOfSurveyOPath from './EndOfSurveyPath.vue'
    import SaveOrSend from './SaveOrSend.vue';

    const formStorage = useStageStore();
    const { t } = useI18n();

    const props = defineProps({
        stage: Object,
        route: String
    })

    const getChildIds = (currentStage) => {
		return currentStage?.children;
	}

    const hasQuestionAccess = (nextStepId) => {
        return formStorage.getStageById(nextStepId)[0].access.question
    }
</script>

<template>
    <div class="row">
        <div class="col-md-12">
          <div v-if="getChildIds(props.stage) && getChildIds(props.stage).length > 0" style="margin-top: 0.75rem">
            {{ t('survey-stages-left') }}
          </div>
            <nav class="navbar main-navigation-bar" :aria-label="t('form-steps')">
                <ul class="list-unstyled navbar-nav flex-row">
                    <li v-for="nextStepId in getChildIds(props.stage)" :key="nextStepId" class="nav-item">
                      <div>
                        <router-link 
                            v-if="hasQuestionAccess(nextStepId)"
                            :to="`/${nextStepId}`"
                            class="link-button" 
                            :style="`border-color: ${formStorage.getPathDetailsByStageId(Number(nextStepId))[0]?.color}`"
                        >
                            {{ formStorage.getStageById(nextStepId)[0].title[formStorage.language] }}
                        </router-link>
                        <span
                            v-else
                            class="link-button disabled"
                        >
                            {{ formStorage.getStageById(nextStepId)[0].title[formStorage.language] }}
                        </span>
                      </div>
                      <div v-if="getChildIds(props.stage).length == 1 && !hasQuestionAccess(nextStepId)">
                        <EndOfSurveyOPath
                            :stage="stage"
                            :route="route"
                        />
                        <SaveOrSend />
                      </div>
                    </li>
                </ul>
            </nav>

          <div v-if="getChildIds(props.stage) && getChildIds(props.stage).length == 0">
            <EndOfSurveyOPath
                :stage="stage"
                :route="route"
            />
            <SaveOrSend />
          </div>

        </div>
    </div>
</template>